import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ChefHat } from "lucide-react";
import { BrandMark } from "@/components/Brand";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // session_id is in URL fragment (#session_id=xxx), NOT query string
    const hash = loc.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      const res = await exchangeGoogleSession(sessionId);
      // Clear fragment immediately so refresh doesn't re-trigger
      window.history.replaceState({}, document.title, window.location.pathname);
      if (!res.ok) {
        toast.error(res.error || "Google sign-in failed");
        nav("/login", { replace: true });
        return;
      }
      toast.success(`Welcome${res.user.name ? `, ${res.user.name.split(" ")[0]}` : ""}!`);
      const u = res.user;
      if (u.role === "admin") nav("/admin", { replace: true });
      else if (u.role === "chef") nav("/chef", { replace: true });
      else nav(u.onboarded ? "/app" : "/onboarding", { replace: true });
    })();
  }, [exchangeGoogleSession, loc.hash, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="w-14 h-14 mx-auto flex items-center justify-center animate-pulse">
          <BrandMark size={56}/>
        </div>
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
